export interface CreateMagazineBookNumberListRequest {
  bibliographySetId: number
  searchList: {
    bibliographyRealId: number
    collectionNo: string
    collectionStatusName: string
    shelfCount: number
    holdingCount: number
    orderCount: number
    reserveCount: number
  }[]
}

export function CreateMagazineBookNumberListRequestToJSON(
  value: CreateMagazineBookNumberListRequest
): any {
  return {
    bibliography_set_id:
      value.bibliographySetId !== 0 ? value.bibliographySetId : undefined,
    search_list:
      value.searchList.length > 0
        ? value.searchList.map(searchData => {
            return {
              bibliography_real_id:
                searchData.bibliographyRealId !== 0
                  ? searchData.bibliographyRealId
                  : undefined,
              collection_no:
                searchData.collectionNo !== ''
                  ? searchData.collectionNo
                  : undefined,
              collection_status_name:
                searchData.collectionStatusName !== ''
                  ? searchData.collectionStatusName
                  : undefined,
              shelf_count:
                searchData.shelfCount !== 0 ? searchData.shelfCount : undefined,
              holding_count:
                searchData.holdingCount !== 0
                  ? searchData.holdingCount
                  : undefined,
              order_count:
                searchData.orderCount !== 0 ? searchData.orderCount : undefined,
              reserve_count:
                searchData.reserveCount !== 0
                  ? searchData.reserveCount
                  : undefined
            }
          })
        : undefined
  }
}
